export const COMMUNITY_ID = 'communityId';
export const YEAR = 'year';
export const PERIOD_FROM = 'periodFrom';
export const PERIOD_TO = 'periodTo';
export const SCHEDULED_ON = 'scheduledOn';
export const FREQUENCY = 'frequency';
export const RUN_TYPE = 'runType';
export const JOB_ID = 'distributionJobId';
export const STATUS = 'active';